module.exports = __webpack_public_path__ + "static/media/2.Traditionaly Untraditional.3e85cf5b.mp3";